import type { PublicSnapshot } from '../../core/types.ts';
import { relTime, usd } from '../lib/format.ts';
import { Pill } from './ui.tsx';

export function Header({ snap, now, stale }: { snap: PublicSnapshot | null; now: number; stale: boolean }) {
  return (
    <header className="sticky top-0 z-30 border-b border-edge bg-ink/85 backdrop-blur-lg">
      <div className="mx-auto flex max-w-[1500px] flex-wrap items-center gap-x-5 gap-y-2 px-4 py-2.5 sm:px-6">
        <div className="flex items-center gap-3">
          <div className="flex -space-x-2.5">
            <img
              src="/logos/shortcoin.png"
              alt="Shortcoin"
              className="size-9 rounded-full ring-2 ring-short/60"
              width={36}
              height={36}
            />
            <img
              src="/logos/longcoin.png"
              alt="Longcoin"
              className="size-9 rounded-full ring-2 ring-long/60"
              width={36}
              height={36}
            />
          </div>
          <div className="leading-tight">
            <h1 className="text-[17px] font-bold tracking-tight">
              <span className="text-short">SHORT</span>
              <span className="text-dim"> / </span>
              <span className="text-long">LONG</span>
            </h1>
            <p className="text-[11px] text-dim">Two memecoins. One trading engine. 25% of every win burned.</p>
          </div>
        </div>

        <div className="ml-auto flex flex-wrap items-center gap-2">
          {snap && (
            <span className="num hidden text-sm text-muted sm:inline">
              <span className="text-dim">AUM</span> {usd(snap.combined.equityUsd)}
            </span>
          )}

          {snap?.killSwitch && (
            <Pill
              tone="down"
              title="The kill switch is engaged. Open positions are still managed to their stops and targets, but no new entry will be taken."
            >
              ■ KILL SWITCH
            </Pill>
          )}

          {snap && (
            <Pill
              tone={snap.mode === 'live' ? 'up' : 'neutral'}
              title={
                snap.mode === 'live'
                  ? 'Signing real transactions on Solana'
                  : 'Simulated fills against live market prices. No real funds at risk.'
              }
            >
              {snap.mode === 'live' ? 'LIVE TRADING' : 'PAPER MODE'}
            </Pill>
          )}

          <Pill tone={stale ? 'down' : 'up'} title={stale ? 'The engine has not reported in recently' : undefined}>
            <span className={`size-1.5 rounded-full ${stale ? 'bg-down' : 'heartbeat bg-up'}`} aria-hidden />
            {snap ? `tick ${relTime(snap.lastTickAt, now)}` : 'connecting…'}
          </Pill>
        </div>
      </div>
    </header>
  );
}
